import React, { Component } from "react";
import {
    Col,
    Row,
    Spin,
    message,
    Form,
    Typography,
} from "antd";
import "../../../style/sample.css";
import LoadingButton from '@mui/lab/LoadingButton';
import { backendGet, backendPostWithoutRefresh } from "../../../helpers/callBackend";
import GenericModal from "../../buttons/genericModal";
import ImageUpload from "../checkDeposits/uploadImage";
import GenerateCode from "../../formItems/generateCode";
import CircularProgress from '@mui/material/CircularProgress';

const { Text } = Typography;
export default class CheckImageView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checkFrontImage: null,
            checkBackImage: null,
            checkImagesModalVisible: false,
            loading: true,
            check_images_back: "",
            check_images_front: "",
            submitting: false,
            verificationToken: "",
        };
    }

    getCheckImages = (recordId, recordType) => {
        backendGet(
            this,
            "/api/payments/check-images",
            {
                params: {
                    bankAccountId: this.props.bankAccountId,
                    checkId: recordId,
                    checkType: recordType,
                },
            },
            "",
            (s, d) => {
                if (!d.front_image) {
                    message.error("This check is does not have a front image");
                }
                if (!d.back_image) {
                    message.error("This check is does not have a back image");
                }
                s["checkFrontImage"] = d.front_image
                    ? d.front_image
                    : "No Image Available";
                s["checkBackImage"] = d.back_image
                    ? d.back_image
                    : "No Image Available";
                s["loading"] = false;
                return s;
            }
        );
    };

    handleVerificatonCode = async (values) => {
        this.setState({
            ...this.state,
            verificationToken: values.verificationToken,
            verificationCode: values.verificationCode,
        });
    };

    onCheckSubmit = (formData) => {
        const data = { ...formData };
        data["checkId"] = this.props.record.id;
        data["bankAccountId"] = this.props.bankAccountId;
        data["verificationToken"] = this.state.verificationToken;
        data["checkType"] = this.props.record.type;

        this.setState({ submitting: true });

        const promises = []
        if (this.state.check_images_back) {
            promises.push(backendPostWithoutRefresh("/api/payments/check-images/", {
                ...data,
                side: "back",
                image: this.state.check_images_back,
            }))
        }


        if (this.state.check_images_front) {
            promises.push(backendPostWithoutRefresh("/api/payments/check-images/", {
                ...data,
                side: "front",
                image: this.state.check_images_front,
            }))
        }

        Promise.all(promises)
            .then((response) => {
                this.setState({
                    checkImagesModalVisible: false,
                    submitting: false,
                });
            })
            .catch(() => {
                this.setState({ submitting: false });
            });

    };

    render() {
        return (

            <div
                style={{
                    cursor: "pointer",
                }}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                <GenericModal
                    visible={this.state.checkImagesModalVisible}
                    handleCancelModal={() => {
                        this.setState({
                            checkFrontImage: null,
                            checkBackImage: null,
                            checkImagesModalVisible: false,
                            loading: true,

                            check_images_back: "",
                            check_images_front: "",
                            submitting: false,
                            verificationToken: "",
                        });
                    }}
                    showModal={() => {
                        this.setState({
                            checkFrontImage: null,
                            checkBackImage: null,
                            checkImagesModalVisible: true,
                            loading: true,

                            check_images_back: "",
                            check_images_front: "",
                            submitting: false,
                            verificationToken: "",
                        });
                        this.getCheckImages(
                            this.props.record.id,
                            this.props.record.type
                        );
                    }}
                    size="md"
                    button={<div>View Check</div>}
                    modalTitle="Check Images"
                    modalBody={
                        <Col>
                            <Form
                                layout="vertical"
                                name="basic"
                                onFinish={this.onCheckSubmit}
                                autoComplete="off"
                            >
                                <Row
                                    style={{
                                        fontSize: "16px",
                                        marginBottom: "10px",
                                    }}
                                >
                                    Front
                                </Row>
                                <Row style={{ display: "flex" }}>
                                    {!this.state.loading ? (
                                        this.state
                                            .checkFrontImage ===
                                            "No Image Available" ? (
                                            <div
                                                style={{
                                                    width: "80%",
                                                    margin: "auto",
                                                }}
                                            >
                                                <Form.Item
                                                    label={
                                                        <Text
                                                            italic
                                                            type="secondary"
                                                        >
                                                            No image
                                                            found.
                                                            Please
                                                            upload.
                                                        </Text>
                                                    }
                                                    name="check_images_front"
                                                >
                                                    <ImageUpload
                                                        onChange={(
                                                            data
                                                        ) => {
                                                            let newState =
                                                                { ...this.state };
                                                            newState[
                                                                "check_images_front"
                                                            ] =
                                                                data;
                                                            this.setState(
                                                                newState
                                                            );
                                                        }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        ) : (
                                            <img
                                                src={`data:image/jpeg;base64,${this.state.checkFrontImage}`}
                                                style={{
                                                    width: "80%",
                                                    border: "none",
                                                    margin: "auto",
                                                }}
                                                alt="Front view of check"
                                            />
                                        )
                                    ) : (
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px', width: '100%' }}>
  <CircularProgress />
</div>
                                    )}
                                </Row>
                                <Row
                                    style={{
                                        fontSize: "16px",
                                        marginBottom: "10px",
                                        marginTop: "10px",
                                    }}
                                >
                                    Back
                                </Row>
                                <Row>
                                    {!this.state.loading ? (
                                        this.state
                                            .checkBackImage ===
                                            "No Image Available" ? (
                                            <div
                                                style={{
                                                    width: "80%",
                                                    margin: "auto",
                                                }}
                                            >
                                                <Form.Item
                                                    label={
                                                        <Text
                                                            italic
                                                            type="secondary"
                                                        >
                                                            No image found.
                                                            Please upload.
                                                        </Text>
                                                    }
                                                    name="check_images_back"
                                                >
                                                    <ImageUpload
                                                        onChange={(
                                                            data
                                                        ) => {
                                                            let newState =
                                                                { ...this.state };
                                                            newState[
                                                                "check_images_back"
                                                            ] =
                                                                data;
                                                            this.setState(
                                                                newState
                                                            );
                                                        }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        ) : (
                                            <img
                                                src={`data:image/jpeg;base64,${this.state.checkBackImage}`}
                                                style={{
                                                    width: "80%",
                                                    border: "none",
                                                    margin: "auto",
                                                }}
                                                alt="Back view of check"
                                            />
                                        )
                                    ) : (
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px', width: '100%' }}>
  <CircularProgress />
</div>
                                    )}
                                </Row>

                                {(this.state.checkFrontImage ===
                                    "No Image Available" ||
                                    this.state.checkBackImage ===
                                    "No Image Available") && (
                                        <Row
                                            style={{
                                                marginTop: "20px",
                                            }}
                                        >
                                            <GenerateCode
                                                bankAccountId={
                                                    this.props
                                                        .bankAccountId
                                                }
                                                onChange={
                                                    this
                                                        .handleVerificatonCode
                                                }
                                            />
                                            <Form.Item>
                                                <LoadingButton
                                                    disableElevation 
                                                    fullWidth 
                                                    size="small" 
                                                    type="submit" 
                                                    variant="contained" 
                                                    color="primary"
                                                    htmlType="submit"
                                                    sx={{ fontSize: 12, textTransform: 'none' }}
                                                    loading={this.state.submitting}
                                                    style={{
                                                        margin: "3px",
                                                        width: "100%",
                                                    }}
                                                >
                                                    Upload
                                                </LoadingButton>
                                            </Form.Item>
                                        </Row>
                                    )}
                            </Form>
                        </Col>
                    }
                />
            </div>
        );
    }
}
